import stockPhotosImg from '@/assets/images/stock-photo.jpg';
import stockVideoImg from '@/assets/images/stock-videos.jpg';
import leadMagnetsImg from '@/assets/images/lead-magnets.jpg';

export default [
    {
        title: "Lead Magnets",
        subtitle: "Digital Assets",
        platform: '',
        category: 'Lead Magnets',
        thumbnail: leadMagnetsImg,
        icon: null,
        url: null,
        theme: null
    },
    {
        title: "Stock Videos",
        subtitle: "Digital Assets",
        platform: '',
        category: 'Stock Videos',
        thumbnail: stockVideoImg,
        icon: null,
        url: null,
        theme: null
    },
    {
        title: "Stock Photos",
        subtitle: "Digital Assets",
        platform: '',
        category: 'Stock Photos',
        thumbnail: stockPhotosImg,
        icon: null,
        url: null,
        theme: null
    },
    // {
    //     title: "Sounds",
    //     subtitle: "Audio for Agents",
    //     platform: '',
    //     category: 'Sounds',
    //     thumbnail: monthlyReelsImg,
    //     icon: null,
    //     url: 'https://www.pinkdoorsocialagent.com/profile/emilygabel0810/reelsreport',
    //     theme: null
    // },
];
  